/* eslint-disable no-undef */
import Vue from 'vue'
import axios from 'axios'
import Cookie from 'common/js/cookie'
import md5 from 'js-md5'
import store from './../store'
// import AutoQuitTips from 'base/auto-quit-tips' // group组件
import { loginInfo, timestamp } from 'common/js/util'
import { Message } from 'element-ui'
import { getCas } from './all'
// let isDev = true; // 是都开发环境
// if (process.env.NODE_ENV === "production") {
//   isDev = false;
// }
var headers = {}
var _config = config
const instance = axios.create({
    // 实例化
    baseURL: _config.url
})
instance.defaults.timeout = 30000
let cancelList = []
// 请求拦截
instance.interceptors.request.use(
    function (config) {
        if ((config.params && config.params.download) || (config.data && config.data.download)) {
            config.responseType = 'blob'
            Vue.prototype.$main.message = {
                text: '正在导出，请稍等',
                type: 'warning'
            }
            if (config.params && config.params.download) delete config.params.download
            if (config.data && config.data.download) delete config.data.download
        }
        // 预先请求默认
        let params = loginInfo()
        if (config.headers['url-type'] === 'moni') {
            // 特殊操作-第三期监控后端新建项目，导致接口地址改变 （第三期接口由'moni'进去判断）
            config.baseURL = _config.urlControl
        }
        if (config.headers['url-type'] === 'count') {
            config.baseURL = _config.countUrl
        }
        if (config.headers['url-type'] === 'point') {
            config.baseURL = _config.pointUrl
        }
        // 设置cancelToken
        config.cancelToken = new axios.CancelToken(function executor(cancel) {
            // 在此处保存取消函数
            cancelList.push({ url: config.baseURL + config.url, cancel })
        })
        config.headers.userCode = params.userCode || '1'
        config.headers.token = params.token || '1'
        config.headers.timestamp = timestamp()
        let param = {
            universityId: params.universityId || _config.universityId,
            clientCategory: params.clientCategory || 'PC',
            operatorId: sessionStorage.getItem('loginInfo') ? JSON.parse(sessionStorage.getItem('loginInfo')).userCode : '0'
        }
        // cas认证退出，token和platType需要以地址的方式传参
        if (config.url.includes('/defauth/loginOut')) {
            param.token = params.token || '1'
            param.platType = 'STANDARD_CAS'
        }
        if (config.method === 'post') {
            if (!config.params || (config.params && !config.params.isUpload)) {
                config.data = config.data ? { ...config.data, ...param } : param
            }
            if (config.params && !config.params.isUpload) {
                config.params = config.params ? Object.assign(config.params, param) : param
            }
        } else {
            config.params = config.params ? Object.assign(config.params, param) : param
        }
        let sign = md5(config.headers.timestamp + config.headers.token + 'yunhua') // 认证
        config.headers.sign = sign.toUpperCase()
        return config
    },
    function (error) {
        console.log(error, error.response.status)
        //   router.replace({
        //     path: 'login',
        //     query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
        // })
        return Promise.reject(error)
    }
)
// 响应拦截
instance.interceptors.response.use(
    response => {
        if (!response.data) {
            reject(http.getErrorzt('请求缺少响应'))
            return false
        }
        if (response.config.responseType === 'blob') {
            download(response)
        } else if (response.data.code === '40001') {
            return response.data
        } else {
            if (response.data.code === '30006' || response.data.code === '30007') {
                if (!response.config.url.includes('/defauth/getCasAddress') && !response.config.url.includes('/defauth/loginOut')) {
                    // 别处登陆异常状态
                    let index = cancelList.findIndex(item => item.url === response.config.url)
                    cancelList.forEach((item, i) => {
                        if (i >= index) {
                            item.cancel() // 取消请求
                        }
                    })
                    cancelList = []
                    http.togoUrlAnomaly(response) // 异常状态
                }
            } else {
                Message({
                    message: response.data.message,
                    type: 'error',
                    duration: 2 * 1000
                })
                return response.data
            }
        }
    },
    error => {
        if (error instanceof Cancel) {
        } else {
            Message({
                message: error,
                type: 'error',
                duration: 2 * 1000
            })
        }
        // Promise.reject(http.getErrorzt(error));
        // Promise.reject(error);
    }
)
// application/x-www-form-urlencoded： 窗体数据被编码为名称/值对。这是标准的编码格式。
// multipart/form-data： 窗体数据被编码为一条消息，页上的每个控件对应消息中的一个部分。
// text/plain： 窗体数据以纯文本形式进行编码，其中不含任何控件或格式字符。 * 空格转换为 “+” 加号，但不对特殊字符编码。
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
// axios.interceptors.response.use
const http = {
    exportGet: (url, params, urlType = undefined) => {
        headers['url-type'] = urlType
        return new Promise((resolve, reject) => {
            instance
                .get(url, {
                    method: 'get',
                    url: url,
                    params: params,
                    headers: headers,
                    responseType: 'blob'
                })
                .then(response => {
                    console.log(108, response)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // urlType 后端接口项目地址
    get: (url, params, urlType = undefined) => {
        headers['url-type'] = urlType
        return new Promise((resolve, reject) => {
            instance
                .get(url, {
                    params: params,
                    headers: headers
                })
                .then(res => {
                    resolve(res)
                })
        })
    },
    post: (url, data, params, urlType = undefined) => {
        headers['url-type'] = urlType
        headers['Content-Type'] = 'application/json'
        return new Promise((resolve, reject) => {
            instance({
                method: 'post',
                url: url,
                data: data,
                params: params,
                headers: headers
            })
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    delete: function (url, params, urlType = undefined) {
        headers['url-type'] = urlType
        return new Promise((resolve, reject) => {
            instance
                .delete(url, {
                    params: params,
                    headers: headers
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    put: function (url, data, params, urlType = undefined) {
        headers['url-type'] = urlType
        headers['Content-Type'] = 'application/json'
        return new Promise((resolve, reject) => {
            instance({
                method: 'put',
                url: url,
                data: data,
                params: params,
                headers: headers
            })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    qsPost: function (url, data, params, urlType = undefined, isUpload) {
        headers['url-type'] = urlType
        headers['Content-Type'] = 'application/x-www-form-urlencoded' // 默认form-data提交
        if (isUpload) headers['Content-Type'] = 'multipart/form-data' // 上传图片
        // 当action为get时候，浏览器用x-www-form-urlencoded的编码方式把form数据转换成一个字串（name1=value1&name2=value2…），然后把这个字串append到url后面，用?分割，加载这个新的url。
        // 当action为post时候，浏览器把form数据封装到http body中，然后发送到server。 如果没有type=file的控件，用默认的application/x-www-form-urlencoded就可以了。 但是如果有type=file的话，就要用到multipart/form-data了。浏览器会把整个表单以控件为单位分割，并为每个部分加上Content-Disposition(form-data或者file),Content-Type(默认为text/plain),name(控件name)等信息，并加上分割符(boundary)。
        return new Promise((resolve, reject) => {
            instance({
                url,
                method: 'post',
                transformRequest: isUpload
                    ? null
                    : [
                          function (data) {
                              let ret = ''
                              for (let it in data) {
                                  ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                              }
                              return ret
                          }
                      ],
                data: data,
                params: { isUpload: isUpload },
                headers: headers
            })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getErrorzt: function (message) {
        var name = ''
        if (message.search(/Network Error/i) !== -1) {
            name = '无可用网络' // 无可用网络
        }
        // else if (message.search(/timeout/i) !== -1) {
        //   name = '请求超时' // 请求超时
        // }//根据后端和测试要求屏蔽请求超时提示（一个页面多个接口一个挂了就全部挂了）
        else if (message.search(/404/) !== -1) {
            name = '404' // 404
        } else if (message.search(/403/) !== -1) {
            name = '403' // 403
        } else if (message.search(/400/) !== -1) {
            name = '400' // 400
        }
        Cookie.delCookie('contSum') // 登录解除-验证次数归零
        Cookie.delCookie('userInfo') // 登录解除-验证次数归零
        // login页面不显示
        Vue.prototype.$main.textNull = Vue.prototype.$main.$route.name.includes('login') ? '' : name
        return name // 暂无数据
    },
    // 别处登陆异常状态
    togoUrlAnomaly: function (response) {
        if (sessionStorage.getItem('loginInfo')) {
            Vue.prototype.$main.message = {
                text: response.data.message || '此账号在别处登录',
                type: 'error'
            }
        }
        let loginType = sessionStorage.getItem('loginInfo') ? JSON.parse(sessionStorage.getItem('loginInfo')).loginType : ''
        if (loginType === 'self') {
            // 退出成功，清空缓存并重定向到cas登录地址
            Cookie.delCookie('contSum') // 登录解除-验证次数归零
            Cookie.delCookie('userInfo') // 登录解除-验证信息清除
            Cookie.delCookie('evaluate_front_login_access_token')
            store.commit('set_commonality', {})
            sessionStorage.removeItem('commonality')
            sessionStorage.removeItem('loginInfo')
            sessionStorage.removeItem('token')
            Vue.prototype.$main.$router.replace('/login/sail')
        } else if (loginType === 'teacherQuestionnaire') {
            Cookie.delCookie('contSum') // 登录解除-验证次数归零
            Cookie.delCookie('userInfo') // 登录解除-验证信息清除
            Cookie.delCookie('evaluate_front_login_access_token')
            store.commit('set_commonality', {})
            sessionStorage.removeItem('commonality')
            // sessionStorage.removeItem("loginInfo");
            sessionStorage.removeItem('token')
            Vue.prototype.$main.$router.replace('/login/sail')
        } else {
            Cookie.delCookie('contSum') // 登录解除-验证次数归零
            Cookie.delCookie('userInfo') // 登录解除-验证信息清除
            Cookie.delCookie('evaluate_front_login_access_token')
            store.commit('set_commonality', {})
            sessionStorage.removeItem('commonality')
            sessionStorage.removeItem('loginInfo')
            sessionStorage.removeItem('token')
            // 获取cas地址并跳转
            getCas({ sysCode: 'evaluatefront' }).then(res => {
                let jumpPageKey = sessionStorage.getItem('jumpPageKey') || 'pc_tch_eval'
                window.location.href = `${res.content}${jumpPageKey}`
            })
        }
    }
}
// 下载
const download = response => {
    if (response.data.type === 'application/json') {
        // 导出失败
        const reader = new FileReader() //创建一个FileReader实例
        reader.readAsText(response.data, 'utf-8') //读取文件,结果用字符串形式表示
        reader.onload = function () {
            //读取完成后,**获取reader.result**
            let infos = JSON.parse(reader.result)
            Message({
                message: infos.message,
                type: 'error',
                duration: 2 * 1000
            })
        }
        return false
    } else if (response.data.type === 'text/xml') {
        var utf8decoder = new TextDecoder()
        var fr = new FileReader()
        fr.readAsArrayBuffer(response.data)
        fr.onload = function (res) {
            var buffer = fr.result
            var text = utf8decoder.decode(buffer)
            Message({
                message: text,
                type: 'error',
                duration: 2 * 1000
            })
        }
        return false
    } else {
        //存表头名，用于下载的时候使用
        let tableName = ''
        if (response.headers['content-disposition']) {
            let name = response.headers['content-disposition'].split(';')[1].split('=')[1]
            tableName = decodeURI(escape(name))
        }
        let blob = new Blob([response.data], {}) // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob) // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement('a')
        a.href = url
        a.download = tableName
        a.click()
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url)
    }
}
// export default http
Vue.prototype.$http = http
Vue.prototype.axios = axios
export { http, axios }



// WEBPACK FOOTER //
// ./src/api/http.js